import champions from "../data/historical_2002.json";
import { darkTeams, noShadowTeams } from "../hooks/vars";
import teamsBasic from "../data/teamsBasic2025.json";
import "../css/champs.css";

export function Champions() {
  return (
    <div className="defaultModal champModule">
      <h3>'MEMBER? I 'MEMBER.</h3>
      <ChampionsList />
    </div>
  );
}

function ChampionsList() {
  const champList = champions
    .sort((a, b) => b.year - a.year)
    .map((data, i) => {
      let afc = data.afc_abbr;
      let afcName = data.afc_champion;
      let nfc = data.nfc_abbr;
      let nfcName = data.nfc_champion;
      let sb = data.sb_abbr;
      // let sbName = data.super_bowl_champion;
      let sbRoman = data.super_bowl;
      let sbLoc = data.super_bowl_location;
      let sbStad = data.super_bowl_stadium;
      let afcWin = false;
      let nfcWin = false;

      //console.log(theTeam);

      if (afc === sb) afcWin = true;
      if (nfc === sb) nfcWin = true;

      return (
        <div className="champRow" key={i}>
          <div className="thisYear">
            <div className="year">{data.year}</div>
            <div className="sbX">Super Bowl {sbRoman}</div>
          </div>

          <div className="sbInfo">
            <div className="sbMatchup">
              <TeamCard t={afc} n={afcName} w={afcWin} c="sbCard" />
              <TeamCard t={nfc} n={nfcName} w={nfcWin} c="sbCard" />
            </div>
            <div className="sbLoc">
              {sbStad} | {sbLoc}
            </div>
          </div>

          <div className="mvps">
            <div className="mvp">
              <h3>League MVP</h3>
              <TeamCard
                t={data.mvp_team_abbr}
                n={data.league_mvp}
                w={false}
                c="mvpCard"
              />
            </div>
            <div className="coty">
              <h3>Coach of the Year</h3>
              <TeamCard
                t={data.coty_team_abbr}
                n={data.coach_oty}
                w={false}
                c="mvpCard"
              />
            </div>
            <div className="sbMvp">
              <h3>Super Bowl MVP</h3>
              <TeamCard t={sb} n={data.super_bowl_mvp} w={false} c="mvpCard" />
            </div>
          </div>

          <div className="divWinners">
            <div className="afcBanners">
              <div className="afcW">
                <div className="divTitle">AFC West Champ</div>
                <div className="divWinner"><TeamCard t={data.afc_w_abbr} n={data.afc_w_champ} w={false} c="divCard" /></div>
              </div>
              <div className="afcN">
                <div className="divTitle">AFC North Champ</div>
                <div className="divWinner"><TeamCard t={data.afc_n_abbr} n={data.afc_n_champ} w={false} c="divCard" /></div>
              </div>
              <div className="afcS">
                <div className="divTitle">AFC South Champ</div>
                <div className="divWinner"><TeamCard t={data.afc_s_abbr} n={data.afc_s_champ} w={false} c="divCard" /></div>
              </div>
              <div className="afcE">
                <div className="divTitle">AFC East Champ</div>
                <div className="divWinner"><TeamCard t={data.afc_e_abbr} n={data.afc_e_champ} w={false} c="divCard" /></div>
              </div>
            </div>
            <div className="nfcBanners">
              <div className="nfcW">
                <div className="divTitle">NFC West Champ</div>
                <div className="divWinner"><TeamCard t={data.nfc_w_abbr} n={data.nfc_w_champ} w={false} c="divCard" /></div>
              </div>
              <div className="nfcN">
                <div className="divTitle">NFC North Champ</div>
                <div className="divWinner"><TeamCard t={data.nfc_n_abbr} n={data.nfc_n_champ} w={false} c="divCard" /></div>
              </div>
              <div className="nfcS">
                <div className="divTitle">NFC South Champ</div>
                <div className="divWinner"><TeamCard t={data.nfc_s_abbr} n={data.nfc_s_champ} w={false} c="divCard" /></div>
              </div>
              <div className="nfcE">
                <div className="divTitle">NFC East Champ</div>
                <div className="divWinner"><TeamCard t={data.nfc_e_abbr} n={data.nfc_e_champ} w={false} c="divCard" /></div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  return champList;
}

function TeamCard(props) {
  //t=team key n=full name
  const teamData = teamsBasic.find((data) => data.Key === props.t);
  const darkTeam = darkTeams?.includes(teamData?.Key);

  return (
    <div
      className={"champCard " + (props.c || "")}
      key={props.k}
      style={{
        background:
          "linear-gradient(15deg,#000 -100%, #" +
          teamData?.PrimaryColor +
          " 40%)",
        color:
          "#" + (!darkTeam ? teamData?.SecondaryColor : teamData?.TertiaryColor),
        textShadow: noShadowTeams.includes(teamData?.Key)
          ? ".5px .5px 0px #ffffff36"
          : "1px 1px 0 #00000085",
        //border: props.w ? "solid 4px #fff" : "none",
        // borderRadius: props.w ? "12px" : "0",
        //zIndex: props.w ? "101" : "0",
        //opacity: props.w ? 1 : 0.65,
        //boxShadow: props.w ? "0 0 10px #fff" : "",
        // transform: props.w ? "scale(1.05)" : ""
      }}
    >
      <div
        className="teamCardLogo"
        style={{
          backgroundImage: "url(" + teamData?.WikipediaLogoURL + ")",
        }}
      ></div>
      <div className="teamCardName">
        {props.n} {darkTeam}
      </div>
      <div className={props.w ? "lombardi" : "loser"}></div>
    </div>
  );
}
